export const directions = [0 /* right */, 1 /* bottom */, 2 /* left */, 3 /* top */];
function makeDelta(i) {
    const delta = i > 1 ? -1 : 1;
    if (i & 1) {
        return { y: delta, x: 0 };
    }
    else {
        return { x: delta, y: 0 };
    }
}
const deltas = Array.from({ length: 4 }).map((_, i) => makeDelta(i));
export function getDelta(side) {
    return deltas[side];
}
export function reverseSide(side) {
    return side ^ 2;
}
export function getPerpendicularCW(side) {
    return (side + 1) & 3;
}
export function getPerpendicularCCW(side) {
    return (side + 3) & 3;
}
export function makePositive(side) {
    return side & 1;
}
export function getTravel(side) {
    return makePositive(getPerpendicularCW(side));
}
export function rotate(side, by) {
    return (side + by) & 3;
}
export function reflect(side, { x, y }) {
    return (side & 1 ? y : x) ? reverseSide(side) : side;
}
export function invertReflection({ x, y }) {
    return { x: !x, y: !y };
}
export function mergeReflections({ x, y }, { x: x2, y: y2 }) {
    return {
        x: x !== x2,
        y: y !== y2
    };
}
export function getOffside(posn) {
    if (posn.x > 1)
        return 0 /* right */;
    if (posn.x < -1)
        return 2 /* left */;
    if (posn.y > 1)
        return 1 /* bottom */;
    if (posn.y < -1)
        return 3 /* top */;
    return -1;
}



//////////////////
// WEBPACK FOOTER
// ./src/Side.ts
// module id = 1
// module chunks = 0